import React from 'react';
import { ListItem, Menu } from '../DefaultMenu/styles';
import { NavLink } from 'react-router-dom';
import busIcon from 'assets/images/busIcon.svg';
import binoculars from 'assets/images/binoculars.svg';

const MenuSeturDados: React.FC = () => {
  return (
    <Menu>
      <ul>
        <ListItem>
          <NavLink activeClassName="selected" className="observatory-tourist" to="/admin/observatory-tourist/overview">
            <img src={binoculars} alt="icon for observatory" />
            <span>Observatório Turístico</span>
          </NavLink>
        </ListItem>
        <ListItem>
          <NavLink activeClassName="selected" to="/admin/excursions">
            <img src={busIcon} alt="icon for list item" />
            <span>Excursões</span>
          </NavLink>
        </ListItem>
      </ul>
    </Menu>
  );
};

export default MenuSeturDados;
